// libs
import React, { useRef, useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import { sendEmail } from '../actions/email/index';
import { sendAlert } from '../actions/alert/index';

// UI components
import Logo from '../components/LogoHorizontal.js';
import LoaderModal from '../components/LoaderModal';
import Alert from '../components/Alert.js';

// helpers
import { formatNumber } from '../formatting/phone';
import { logAnalyticsEvent } from '../helpers/analytics';

// vars
import { APPOINTMENT_URL } from '../vars/constants';

// styles
import '../css/home2.css';

let Home2 = ({ error, sendEmail, sendAlert }) => {
    const [leadName, setLeadName] = useState('');
    const [leadEmail, setLeadEmail] = useState('');
    const [leadPhoneNumber, setLeadPhoneNumber] = useState('');
    const [leadMessage, setLeadMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [alertIsOpen, setAlertIsOpen] = useState(false);
    const [leadFormSubmitted, setLeadFormSubmitted] = useState(false);
    const contactFormRef = useRef(null);
    const nameInputRef = useRef(null);

    useEffect(() => {
        if (error.message) {
            setAlertIsOpen(true);
            setIsLoading(false);
        }
    }, [error.message]);

    const handleGetQuote = () => {
        if (contactFormRef.current) {
            contactFormRef.current.scrollIntoView({ behavior: 'smooth' });
            nameInputRef.current.focus();
        }
    };

    async function submitLeadForm(e) {
        e.preventDefault();
        if (!leadName || !leadEmail || !leadPhoneNumber || !leadMessage) {
            window.alert('Please complete all required fields');
        } else {
            setIsLoading(true);

            await logAnalyticsEvent({
                action: 'form_submit',
                category: 'Form',
                label: 'h2 - lead form',
            });

            const messageToLead = {
                email: leadEmail,
                subject: `Thanks for Reaching Out – We’ll Be in Touch Soon!`,
                label: 'Estimate Request',
                body:
                    `<p style="margin-bottom: 15px">Greetings from Yarden!</p>` +
                    '<p>We received your garden estimate request and just wanted to let you know we’re on it. A member of our team will be giving you a call shortly to learn more about what you’re looking for and how we can help.</p>',
            };

            // send confirmation email to lead
            await sendEmail(messageToLead);

            const mesageToHQ = {
                email: 'info@yardengarden.com',
                subject: `Yarden - (ACTION REQUIRED) New Lead`,
                label: 'Website Lead',
                body:
                    '<p>Hello <b>Yarden HQ</b>,</p>' +
                    '<p>A new contact request has been created through the website lead form.</p>' +
                    '<table style="margin: 0 auto;" width="600px" cellspacing="0" cellpadding="0" border="0">' +
                    '<tr>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><b>Lead Name</b></p>' +
                    '</td>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><em>' +
                    leadName +
                    '</em></p>' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><b>Email</b></p>' +
                    '</td>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><em>' +
                    leadEmail +
                    '</em></p>' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><b>Phone Number</b></p>' +
                    '</td>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><em>' +
                    leadPhoneNumber +
                    '</em></p>' +
                    '</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><b>Message</b></p>' +
                    '</td>' +
                    '<td>' +
                    '<p style="margin-bottom: 0px"><em>' +
                    leadMessage +
                    '</em></p>' +
                    '</td>' +
                    '</tr>' +
                    '</table>',
            };

            // send email to Yarden HQ
            await sendEmail(mesageToHQ);

            // send Slack alert to Yarden HQ
            await sendAlert({
                channel: 'website-leads',
                text: `*New Website Lead!*
                \n\nSOURCE\nH2 Lead Form
                \n\nNAME\n${leadName}
                \n\nEMAIL\n${leadEmail}\n\nPHONE NUMBER\n${leadPhoneNumber}
                \n\nMESSAGE\n${leadMessage}\n`,
            });

            setLeadFormSubmitted(true);
            setIsLoading(false);
        }
    }

    return (
        <div>
            {/* Modals */}
            <LoaderModal isOpen={isLoading} />
            <Alert
                isOpen={alertIsOpen}
                message={error.message}
                onClose={() => setAlertIsOpen(false)}
            />

            {/* Header */}
            <div
                style={{
                    backgroundColor: '#003300',
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'center',
                    padding: 10,
                }}
            >
                <div>
                    <p
                        style={{
                            marginBottom: 5,
                            fontSize: 15,
                            textAlign: 'center',
                        }}
                    >
                        CALL US TODAY!
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginBottom: 5,
                        }}
                    >
                        <button
                            className="small"
                            style={{
                                backgroundColor: 'white',
                                color: '#003300',
                                border: 'none',
                            }}
                            onClick={async () => {
                                await logAnalyticsEvent({
                                    action: 'click',
                                    category: 'Button',
                                    label: 'h2 - phone number button',
                                });

                                window.location.href = 'tel:4152313183';
                            }}
                        >
                            (415) 231-3183
                        </button>
                    </div>
                </div>
            </div>
            <div
                style={{
                    padding: 15,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <div style={{ flex: 1 }}>
                    <Logo height={26} />
                </div>
                <div style={{ flex: 1, textAlign: 'center' }}>
                    <h5 style={{ color: '#000', marginBottom: 10 }}>
                        Your Trusted Gardener
                    </h5>
                    <p style={{ fontSize: 10 }}>
                        Fully Insured • Honest Assessment • Hassle Free Service
                    </p>
                </div>
                <div
                    style={{ flex: 1, display: 'flex', justifyContent: 'end' }}
                >
                    <button
                        className="small"
                        style={{
                            backgroundColor: '#003300',
                            border: 'none',
                            color: '#fff',
                            borderRadius: '45px',
                        }}
                        onClick={async () => {
                            await logAnalyticsEvent({
                                action: 'click',
                                category: 'Button',
                                label: 'h2 - book now button',
                            });

                            window.location.href = APPOINTMENT_URL;
                        }}
                    >
                        BOOK NOW
                    </button>
                </div>
            </div>

            {/* Hero Section */}
            <div
                style={{
                    textAlign: 'center',
                    padding: '150px 20px',
                    background:
                        'url(https://www.ziprecruiter.com/svc/fotomat/public-ziprecruiter/cms/600133272Gardener.jpg=ws1280x960) center/cover no-repeat',
                    color: '#fff',
                    backgroundSize: 'cover',
                    width: '100vw',
                    height: 'fit-content',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        backgroundColor: 'black',
                        opacity: '0.4',
                        inset: 0,
                    }}
                ></div>

                <div
                    style={{
                        position: 'relative',
                        zIndex: 10,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div>
                        <h1
                            style={{
                                fontSize: '3rem',
                                marginBottom: '20px',
                                color: 'white',
                            }}
                        >
                            Vegetable gardeners in San Francisco Bay Area
                        </h1>
                        <p>We design, build, and maintain vegetable gardens</p>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <button
                                onClick={handleGetQuote}
                                style={{
                                    backgroundColor: '#003300',
                                    border: 'none',
                                    padding: '20px 30px',
                                    color: '#fff',
                                    fontSize: '1rem',
                                    cursor: 'pointer',
                                    borderRadius: '45px',
                                }}
                            >
                                GET FREE QUOTE
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Lead Form */}
            {!leadFormSubmitted && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div ref={contactFormRef} className="lead-form-h2">
                        <form onSubmit={(e) => submitLeadForm(e)}>
                            <input
                                ref={nameInputRef}
                                value={leadName}
                                type="text"
                                placeholder="Name"
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: 'white',
                                }}
                                onChange={(e) => setLeadName(e.target.value)}
                            />
                            <input
                                value={leadEmail}
                                type="email"
                                placeholder="Email"
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: 'white',
                                }}
                                onChange={(e) => setLeadEmail(e.target.value)}
                            />
                            <input
                                value={formatNumber(leadPhoneNumber)}
                                type="tel"
                                placeholder="Phone"
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: 'white',
                                }}
                                onChange={(e) =>
                                    setLeadPhoneNumber(e.target.value)
                                }
                            />
                            <textarea
                                value={leadMessage}
                                rows={4}
                                placeholder="Message"
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    padding: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: 'white',
                                }}
                                onChange={(e) => setLeadMessage(e.target.value)}
                            ></textarea>
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: '#009900',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    cursor: 'pointer',
                                    width: '100%',
                                    marginTop: 25,
                                }}
                            >
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* Confirmation Message */}
            {leadFormSubmitted && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        minHeight: 400,
                        textAlign: 'center',
                        padding: 15,
                    }}
                >
                    <div>
                        <h4
                            style={{
                                color: 'black',
                                marginBottom: 15,
                                marginTop: 15,
                            }}
                        >
                            Thanks for Reaching Out – We’ll Be in Touch Soon!
                        </h4>
                        <p>
                            A member of our team will be giving you a call
                            shortly to learn more about what you’re looking for
                            and how we can help
                        </p>
                    </div>
                </div>
            )}

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 25,
                }}
            >
                © {new Date().getFullYear()} Yarden Garden Inc
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        error: state.error,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            sendEmail,
            sendAlert,
        },
        dispatch,
    );
}

Home2 = connect(mapStateToProps, mapDispatchToProps)(Home2);

export default Home2;
